import { render, staticRenderFns } from "./PlaceCategoryCard.vue?vue&type=template&id=05ae7638&"
import script from "./PlaceCategoryCard.vue?vue&type=script&lang=js&"
export * from "./PlaceCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports